import React from 'react';
import { useState, useRef, useLayoutEffect,useCallback } from "react";
import blobPath from './MyMapUtils/blobPath';
import fitBounds from './MyMapUtils/fitBounds';
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import SaveIcon from '@mui/icons-material/Save';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import EmailIcon from '@mui/icons-material/Email';
import IconButton from '@mui/material/IconButton';
import Button from '@mui/material/Button';
import LoopIcon from '@mui/icons-material/Loop';
import ErrorIcon from '@mui/icons-material/Error';
import InfoIcon from '@mui/icons-material/Info';
import GetManagementStatus from './MyMapUtils/GetManagementStatus';
import GetReportTypes from './MyMapUtils/GetReportTypes';
const ManagementStatus = window.SIMPL.ManagementStatus;

export default function ActiveDataPanelReport(props) {
    const commentRef = useRef(null);
    const memoRef = useRef(null);
    const reportStatusRef = useRef(null);
    const ActiveDataPanelRef = useRef(null);
    const [infoAreaHeight, setInfoAreaHeight] = useState(0);
    const [accordionHeight, setAccordionHeight] = useState(0);
    const [showFukidasi2, setShowFukidasi2] = useState(false);
    
    const latRef = useRef(null);
    const lngRef = useRef(null);
    const undoLat = props.selectedItem?.originalDataLocationSettingFlg ? props.selectedItem?.originalData_lat : props.defaultLocation[0];
    const undoLng = props.selectedItem?.originalDataLocationSettingFlg ? props.selectedItem?.originalData_lng : props.defaultLocation[1];

    function getLeft(val,type) {
        //ActiveDataPanelのpadding+InfoAreaのmargin+Itemのpadding+項目名のwidth+span+iconのmargin+iconのsize=131
        var size = val === null ? 190 : 131 + val?.current?.clientWidth;
        return {
            left: size +"px",
            width:type === "location" ? "250px":"213px"
        };
    }

    //編集内容のクリア+編集モード解除
    function onClear(){
        props.editClear(true);
    }
    
    //位置情報を通報時の設定に戻す
    function onUndo(){
        //オリジナル位置情報が設定されていない場合、デフォルト値に戻す
        var lat = undoLat;
        var lng = undoLng;

        props.startLatRef.current.value = lat;
        props.startLngRef.current.value = lng;

        let si = props.selectedItem;
        si.startLat = lat;
        si.startLng = lng;
        si.Location.coordinates = [lng,lat];
        props.setSelectedItem(si);
        props.setIsEditLocationAngle(!props.isEditLocationAngle);
        props.setIsEdit(true);

        let LatLng = new window.google.maps.LatLng(lat, lng);
        fitBounds(props.map,null,LatLng,props.mapBoundN,props.mapBoundE,props.mapBoundS,props.mapBoundW + 320);
    }

    //緯度経度、向きのテキストボックスからフォーカスが外れた時の処理
    //いずれかが編集されていた場合は、地図の表示位置を調整
    const onBlurLocationEditArea = useCallback(() => {
        
        let si = props.selectedItem;

        var lat = props.startLatRef.current.value;
        var lng = props.startLngRef.current.value;
        var lat2 = Math.round(lat * 1000000) / 1000000;   //桁の調整
        var lng2 = Math.round(lng * 1000000) / 1000000;   //桁の調整
        
        if(si.startLat !== lat2 || si.startLng !==lng2){
            props.startLatRef.current.value = lat2;
            props.startLngRef.current.value = lng2;
    
            let si = props.selectedItem;
            si.startLat = lat2;
            si.startLng = lng2;
            si.Location.coordinates = [lng2,lat2];
            props.setSelectedItem(si);
            props.setIsEditLocationAngle(!props.isEditLocationAngle);
            props.setIsEdit(true);
    
            let LatLng = new window.google.maps.LatLng(lat2, lng2);
            fitBounds(props.map,null,LatLng,props.mapBoundN,props.mapBoundE,props.mapBoundS,props.mapBoundW + 320);
        }
    }, [props]);

    //緯度経度、向きのテキストボックスでEnterを押した時の処理(Enter=編集が確定した時)
    const onKeyPress = useCallback((e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            onBlurLocationEditArea();
        }
    }, [onBlurLocationEditArea]);

    useLayoutEffect(() => {
        // 管理パネルの高さを再計算
        if (ActiveDataPanelRef.current) {
            let margin = 20*2;  //上下のマージン分
            let workArea = 40;
            let photoArea = 196;
            let titleArea = 41 + 5;
            let gap = 10*2;
            var size = ActiveDataPanelRef.current.clientHeight;
            setInfoAreaHeight(
                size - margin - photoArea - gap - workArea +'px'
            );
            setAccordionHeight(
                size - margin - photoArea - gap - workArea - titleArea +'px'
            );
        }
    }, [props.height]); //ウィンドウ高さが変わったとき

    return (
        <div className={"ActiveDataPanel ActiveDataPanelReport"} ref={ActiveDataPanelRef}>
            <div className='ActiveDataItem'>
                <div className='ActiveDataItem-workArea'>
                    <Button className='ActiveDataItem-button' title={"キャンセル"}
                        onClick={()=>onClear()}
                        variant="text"
                        disabled={props.isUpdate}
                        size="small"
                        sx={{width:"40px",minWidth:"40px",height:"40px",padding:"0",color:"#444444"}}
                        >
                        <ArrowBackIcon fontSize="large" />
                    </Button>
                    <Button className='ActiveDataItem-button' title={"編集する"}
                        onClick={props.setIsEditMode}
                        variant="contained"
                        sx={props.isEditMode ?{display:"none"}:{}}
                        size="small"
                        >
                        <ModeEditIcon/>
                    </Button>
                    <Button className='ActiveDataItem-button' title={"編集を保存"}
                        onClick={()=>props.updateData(props.selectedItem,reportStatusRef.current.value,commentRef.current.value,memoRef.current.value)}
                        variant="contained"
                        sx={!props.isEditMode ?{display:"none"}:{}}
                        disabled={props.isUpdate}
                        size="small"
                        id="saveButton"
                        >
                        {!props.isUpdate ? <SaveIcon /> :<LoopIcon className="loop_Icon"/>}
                    </Button>
                </div>
                <div className="ActiveDataItem-photoArea">
                    {props.selectedItem?.PhotoURL === null ?
                        <div className='ActiveDataItem-NoImage'>No Image</div>
                    :
                        <a href={blobPath(props.selectedItem?.PhotoURL)} target="_blank" rel="noopener noreferrer">
                            <img decoding="async" className="ActiveDataItem-photo2 sr-item-img "
                                src={props.selectedItem !== null ?blobPath(props.selectedItem.ThumbnailURL === null ? props.selectedItem.PhotoURL : props.selectedItem.ThumbnailURL): null}
                                aria-hidden="true" alt="" target="_blank"
                                onMouseEnter={(e) => props.onEnterImg(e, (props.selectedItem?.ThumbnailURL === null ? props.selectedItem.PhotoURL : props.selectedItem.ThumbnailURL)) }    
                                onMouseLeave={(e) => props.onLeaveImg(e, (props.selectedItem?.ThumbnailURL === null ? props.selectedItem.PhotoURL : props.selectedItem.ThumbnailURL)) }
                            />
                        </a>
                    }
                </div>
                <div style={{height:"100%",width:"100%",display:"flex",flexDirection:"row",justifyContent:"space-between"}}>
                    <div className={'ActiveDataItem-infoArea' + (props.isEditMode? " ActiveDataItem-infoArea-edit" : "")} style={{ height: infoAreaHeight}}>
                      
                    {/* タイトル */}
                    <div style={{marginBottom:"5px",display:"flex",justifyContent:"space-between",borderBottom:"1px solid gray"}}>
                        <a href={window.location.origin + '/Detail/Details/' + props.selectedItem?.id}
                            className={"ActiveDataItem-infoArea-title"} style={{minHeight:"30px",margin:"0"}}target="_blank" rel="noopener noreferrer">
                            {props.selectedItem?.title}
                        </a>
                        <IconButton aria-label="メールを作成する"
                            href={'mailto:?'
                            +'subject=【依頼】南砺市防災アプリ通報による道路施設修繕の依頼について'
                            +'&body=%E5%B9%B3%E7%B4%A0%E3%82%88%E3%82%8A%E9%81%93%E8%B7%AF%E7%B6%AD%E6%8C%81%E3%83%BB%E9%99%A4%E9%9B%AA%E9%96%A2%E9%80%A3%E4%BA%8B%E6%A5%AD%E3%81%AB%E3%81%94%E5%8D%94%E5%8A%9B%E3%81%82%E3%82%8A%E3%81%8C%E3%81%A8%E3%81%86%E3%81%94%E3%81%96%E3%81%84%E3%81%BE%E3%81%99%E3%80%82%0D%0A%0D%0A'
                            +'%E3%81%93%E3%81%AE%E5%BA%A6%E3%80%81%E5%8D%97%E7%A0%BA%E5%B8%82%E9%98%B2%E7%81%BD%E3%82%A2%E3%83%97%E3%83%AA%E3%82%88%E3%82%8A%E3%80%81%E9%81%93%E8%B7%AF%E4%BF%AE%E7%B9%95%E7%AE%87%E6%89%80%E3%81%AB%E3%81%A4%E3%81%84%E3%81%A6%E3%81%AE%E6%83%85%E5%A0%B1%E6%8F%90%E4%BE%9B%E3%81%8C%E3%81%82%E3%82%8A%E3%81%BE%E3%81%97%E3%81%9F%E3%80%82' 
                            +'%0D%0A%E3%81%A4%E3%81%8D%E3%81%BE%E3%81%97%E3%81%A6%E3%81%AF%E3%80%81%E4%B8%8B%E8%A8%98%E3%81%AEURL%E3%81%AB%E3%82%A2%E3%82%AF%E3%82%BB%E3%82%B9%E3%81%97%E3%81%A6Google%E3%83%9E%E3%83%83%E3%83%97%E3%81%AE%E4%BD%8D%E7%BD%AE%E6%83%85%E5%A0%B1%E3%83%BB%E5%86%99%E7%9C%9F%E3%83%BB%E3%82%B3%E3%83%A1%E3%83%B3%E3%83%88%E3%82%92%E5%9F%BA%E3%81%AB%E7%8F%BE%E5%9C%B0%E3%82%92%E7%A2%BA%E8%AA%8D%E3%81%97%E3%81%A6%E9%A0%82%E3%81%8D%E3%80%81%E5%AF%BE%E5%BF%9C%E3%81%8C%E5%8F%AF%E8%83%BD%E3%81%A7%E3%81%82%E3%82%8B%E3%81%8B%E3%82%92%E5%88%A4%E6%96%AD%E3%81%97%E3%81%9F%E4%B8%8A%E3%81%A7%E8%A6%8B%E7%A9%8D%E6%9B%B8%E3%81%AE%E6%8F%90%E5%87%BA%E3%82%92%E3%81%8A%E9%A1%98%E3%81%84%E3%81%84%E3%81%9F%E3%81%97%E3%81%BE%E3%81%99%E3%80%82'
                            +'%0D%0A%0D%0A%E5%8D%97%E7%A0%BA%E5%B8%82%E3%82%A4%E3%83%B3%E3%83%95%E3%83%A9%E7%AE%A1%E7%90%86%E3%82%B7%E3%82%B9%E3%83%86%E3%83%A0%E3%80%8CSIMPL%E3%80%8D'
                            +'%0D%0AURL%EF%BC%9Ahttps%3A%2F%2Fsimpl-nanto.azurewebsites.net%2FDetail%2FDetails%2F'+ props.selectedItem?.id
                            +'%0D%0A%0D%0A%E8%A6%8B%E7%A9%8D%E5%B7%A5%E4%BA%8B%E5%90%8D%EF%BC%9A%E5%B8%82%E9%81%93%2A%2A%E7%B7%9A%2A%2A%2A%2A%2A%E4%BF%AE%E7%B9%95'}
                            target="_blank" 
                            >
                            <EmailIcon />
                        </IconButton>
                    </div>
                    
                    <div className="accordion" style={{ height: accordionHeight}}>
                        <div className="accordion-item">
                            <div className="accordion-header">
                                <button type="button" className="accordion-button"
                                    data-toggle="collapse" data-target="#ManagementInfo">
                                    <label>管理情報</label>
                                </button>
                            </div>
                            <div id="ManagementInfo" className="accordion-collapse in">
                                <div>
                                    <div className="accordion-body">

                                        <div className='ActiveDataItem-infoArea-group'>
                                            <div style={{display: "flex",alignItems:"center"}}>
                                                <label className="ActiveDataItem-infoArea-title" style={{height:"24px"}}>地図上の位置情報</label>
                                                {(props.selectedItem?.startLat !== undoLat || props.selectedItem?.startLng !== undoLng) &&
                                                    <InfoIcon color="info" sx={{marginLeft:"10px",height:"24px"}} className='infoIcon' onClick={()=>setShowFukidasi2(!showFukidasi2)}/>
                                                }
                                                {/* 吹き出し */}
                                                {(props.selectedItem?.startLat !== undoLat || props.selectedItem?.startLng !== undoLng) &&
                                                    showFukidasi2 &&
                                                    <div className="fukidashi2" style={getLeft(null,"location")}>
                                                        <p>通報時の値から更新されています。</p>
                                                        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                                                            <div>
                                                                <p style={{marginLeft:"5px"}}>元の緯度：{undoLat}</p>
                                                                <p style={{marginLeft:"5px"}}>元の経度：{undoLng}</p>
                                                            </div>
                                                            {props.isEditMode &&
                                                            <Button id="clearButton"
                                                                onClick={()=>onUndo()}
                                                                variant="outlined"
                                                                size="small"
                                                                sx={{width:"80px",minWidth:"80px",margin:"0",padding:"3px 10px",fontSize:"12px",fontWeight:"bold",backgroundColor:"#ffffff",color:"#444444"}}
                                                                >
                                                                    元に戻す
                                                            </Button>
                                                        }
                                                        </div>
                                                    </div>
                                                }
                                            </div>
                                            <div className='ActiveDataItem-infoArea-item' style={{display: "flex",flexDirection: "column",gap:"2px"}}>
                                                <div className='ActiveDataItem-infoArea-item-group'>
                                                    <label className='ActiveDataItem-infoArea-item-title'>緯度：</label>
                                                    {!props.isEditMode ?
                                                        <label className='ActiveDataItem-infoArea-item-item' ref={latRef}>{props.selectedItem?.startLat}</label>
                                                    :
                                                        <input type='text' className='LocationEditArea' ref={props.startLatRef}
                                                            disabled={props.isUpdate}
                                                            onBlur={()=>onBlurLocationEditArea()} onKeyPress={onKeyPress}
                                                            defaultValue={props.selectedItem !== null && props.selectedItem.startLat !== null ? props.selectedItem?.startLat:null}>
                                                        </input>
                                                    }
                                                    {/* エラーアイコン（ホバーで吹き出し表示） */}
                                                    {!props.isEditMode && (props.selectedItem?.startLat === 0) ?
                                                        <ErrorIcon color="error" sx={{marginLeft:"10px",height:"24px"}} className='errorIcon'/>
                                                        :null
                                                    }
                                                    {/* 吹き出し */}
                                                    <div className="fukidashi" style={getLeft(latRef,"lat")}>
                                                        {props.selectedItem?.startLat === 0 &&
                                                            <p>無効値が設定されています。</p>
                                                        }
                                                    </div>
                                                </div>
                                                <div className='ActiveDataItem-infoArea-item-group'>
                                                    <label className='ActiveDataItem-infoArea-item-title'>経度：</label>
                                                    {!props.isEditMode ?
                                                        <label className='ActiveDataItem-infoArea-item-item' ref={lngRef}>{props.selectedItem?.startLng}</label>
                                                    :
                                                        <input type='text' className='LocationEditArea' ref={props.startLngRef}
                                                            disabled={props.isUpdate}
                                                            onBlur={()=>onBlurLocationEditArea()} onKeyPress={onKeyPress}
                                                            defaultValue={props.selectedItem !== null && props.selectedItem.startLng !== null ? props.selectedItem?.startLng:null}>
                                                        </input>
                                                    }
                                                    {/* エラーアイコン（ホバーで吹き出し表示） */}
                                                    {!props.isEditMode && (props.selectedItem?.startLng === 0) ?
                                                        <ErrorIcon color="error" sx={{marginLeft:"10px",height:"24px"}} className='errorIcon'/>
                                                        :null
                                                    }
                                                    {/* 吹き出し */}
                                                    <div className="fukidashi" style={getLeft(lngRef,"lng")}>
                                                        {props.selectedItem?.startLng === 0 &&
                                                            <p>無効値が設定されています。</p>
                                                        }
                                                    </div>
                                                </div>
                                                {!props.selectedItem?.originalDataLocationSettingFlg &&
                                                    <div className='ActiveDataItem-infoArea-item-group'>
                                                        <label className='ActiveDataItem-infoArea-item-item' style={{color:"red"}}>※通報時に有効な位置情報が設定されていないデータです。</label>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                        <div className='ActiveDataItem-infoArea-group'>
                                            <label className={"ActiveDataItem-infoArea-title"}>通報の状態</label>
                                            {props.isEditMode ?
                                                <div className='ActiveDataItem-infoArea-item' style={{lineHeight: "30px",width:"100%"}}>
                                                    <select style={{height:'30px',width:"100%"}}
                                                        defaultValue={props.selectedItem?.reportStatus}
                                                        ref={reportStatusRef}
                                                        onChange={()=>{
                                                            if(props.selectedItem?.reportStatus !== reportStatusRef.current.value){
                                                                props.setIsEdit(true);
                                                            }
                                                        }}
                                                        disabled={props.isUpdate}>
                                                            {ManagementStatus["reportStatus"].map((data,index)=><option  value={data.no} key={index}>{data.name}</option>)}
                                                    </select>
                                                </div>
                                            :
                                            <label className='ActiveDataItem-infoArea-item'>{GetManagementStatus("reportStatus",props.selectedItem?.reportStatus,"name")}</label>
                                            }
                                        </div>
                                        <div className='ActiveDataItem-infoArea-group'>
                                            <label className={"ActiveDataItem-infoArea-title"}>コメント[公開用]</label>
                                            {props.isEditMode ?
                                                    <div className='ActiveDataItem-infoArea-item' style={{lineHeight: "30px",width:"100%"}}>
                                                        <textarea  id='comment' type="text" style={{width: "100%",height:"70px",resize:"vertical"}}
                                                            defaultValue={props.selectedItem !== null ? props.selectedItem.comment : null}
                                                            ref={commentRef}
                                                            disabled={props.isUpdate}
                                                            onBlur={()=>{
                                                                var text = commentRef.current.value;
                                                                var new_text = text.replace(/\n/g, "");
                                                                if (new_text !== text) {
                                                                    // 元の値と置き換えた値が等しくなければ新しい値に置き換える
                                                                    commentRef.current.value = new_text;
                                                                }
                                                                if(props.selectedItem?.comment !== commentRef.current.value){
                                                                    props.setIsEdit(true);
                                                                }
                                                            }}/>
                                                    </div>
                                            :
                                            <label className='ActiveDataItem-infoArea-item'>{props.selectedItem?.comment}</label>
                                            }
                                        </div>
                                        <div className='ActiveDataItem-infoArea-group'>
                                        <label className={"ActiveDataItem-infoArea-title"}>メモ[内部用]</label>
                                            {props.isEditMode ?
                                                    <div className='ActiveDataItem-infoArea-item' style={{lineHeight: "30px",width:"100%"}}>
                                                        <textarea  id='memo' type="text" style={{width: "100%",height:"70px",resize:"vertical"}}
                                                            defaultValue={props.selectedItem !== null ? props.selectedItem.memo : null}
                                                            ref={memoRef}
                                                            disabled={props.isUpdate}
                                                            onBlur={()=>{
                                                                var text = memoRef.current.value;
                                                                var new_text = text.replace(/\n/g, "");
                                                                if (new_text !== text) {
                                                                    // 元の値と置き換えた値が等しくなければ新しい値に置き換える
                                                                    memoRef.current.value = new_text;
                                                                }
                                                                if(props.selectedItem?.memo !== memoRef.current.value){
                                                                    props.setIsEdit(true);
                                                                }
                                                            }}/>
                                                    </div>
                                            :
                                            <label className='ActiveDataItem-infoArea-item'>{props.selectedItem?.memo}</label>
                                            }
                                        </div>
                                        <div className='ActiveDataItem-infoArea-group'>
                                            <label className={"ActiveDataItem-infoArea-title"}>更新情報</label>
                                            <div className='ActiveDataItem-infoArea-item' style={{display: "flex",flexDirection: "column",gap:"2px"}}>
                                                <div className='ActiveDataItem-infoArea-item-group'>
                                                    <label className='ActiveDataItem-infoArea-item-title'>最終更新日時：</label>
                                                    <label className='ActiveDataItem-infoArea-item-item'>{props.selectedItem?.modifiedDateTime}</label>
                                                </div>
                                                <div className='ActiveDataItem-infoArea-item-group'>
                                                    <label className='ActiveDataItem-infoArea-item-title'>更新者：</label>
                                                    <label className='ActiveDataItem-infoArea-item-item'>{props.selectedItem?.modifiedBy}</label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="accordion-item">
                            <div className="accordion-header">
                                <button type="button" className="accordion-button"
                                    data-toggle="collapse" data-target="#ReportInfo">
                                    <label>通報情報</label>
                                </button>
                            </div>
                            <div id="ReportInfo" className="accordion-collapse in">
                                <div>
                                    <div className="accordion-body">
                                        <div className='ActiveDataItem-infoArea-group'>
                                            <label className={"ActiveDataItem-infoArea-title"}>通報日</label>
                                            <label className='ActiveDataItem-infoArea-item'>{props.selectedItem?.reportDate}</label>
                                        </div>
                                        <div className='ActiveDataItem-infoArea-group'>
                                            <label className={"ActiveDataItem-infoArea-title"}>通報種類</label>
                                            <label className='ActiveDataItem-infoArea-item'>{GetReportTypes(props.selectedItem?.reportType,"name")}</label>
                                        </div>
                                        <div className='ActiveDataItem-infoArea-group'>
                                            <label className={"ActiveDataItem-infoArea-title"}>通報状況</label>
                                            <label className='ActiveDataItem-infoArea-item'>{props.selectedItem?.reportCircumstance}</label>
                                        </div>
                                        {props.isEditMode ?
                                            <div className='ActiveDataItem-infoArea-group'>
                                                <label className={"ActiveDataItem-infoArea-title"}>通報時の位置情報</label>
                                                <div className='ActiveDataItem-infoArea-item' style={{display: "flex",flexDirection: "column",gap:"2px"}}>
                                                    <div className='ActiveDataItem-infoArea-item-group'>
                                                        <label className='ActiveDataItem-infoArea-item-title'>緯度：</label>
                                                        <label className='ActiveDataItem-infoArea-item-item'>{props.selectedItem?.originalData_lat}</label>
                                                    </div>
                                                    <div className='ActiveDataItem-infoArea-item-group'>
                                                        <label className='ActiveDataItem-infoArea-item-title'>経度：</label>
                                                        <label className='ActiveDataItem-infoArea-item-item'>{props.selectedItem?.originalData_lng}</label>
                                                    </div>
                                                </div>
                                            </div>
                                            :
                                            ""
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="accordion-item">
                            <div className="accordion-header">
                                <button type="button" className="accordion-button"
                                    data-toggle="collapse" data-target="#ReporterInfo">
                                    <label>通報者情報</label>
                                </button>
                            </div>
                            <div id="ReporterInfo" className="accordion-collapse in">
                                <div>
                                    <div className="accordion-body">
                                        <div className='ActiveDataItem-infoArea-group'>
                                            <label className={"ActiveDataItem-infoArea-title"}>名前</label>
                                            <label className='ActiveDataItem-infoArea-item'>{props.selectedItem?.name}</label>
                                        </div>
                                        <div className='ActiveDataItem-infoArea-group'>
                                            <label className={"ActiveDataItem-infoArea-title"}>電話番号</label>
                                            <label className='ActiveDataItem-infoArea-item'>{props.selectedItem?.phoneNumber}</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    );
}
